import { ImportQueryService } from "../../../services/payments/ImportQueryService";
import { ImportModel } from "../../models/Import";
import { IQueryImportRepository } from "../../ports/payments/IQueryImportRepository";
import Query from "../Query";

class ImportQuery extends Query<ImportModel> implements IQueryImportRepository {
  constructor(public queryService: ImportQueryService) {
    super(queryService);
  }
}

export default ImportQuery;
